import React from "react";

import HMRC from "assets/images/HMRC.png";
import Which from "assets/images/which-logo.png";
import WinnerAccounting from "assets/images/winner-accounting-excellence.png";
import ContractingAwards from "assets/images/contracting_awards.png";
import TrustPilot from "assets/images/trust-pilot.png";
import UkCloud from "assets/images/uk_cloud.png";
import InnovationAwards from "assets/images/innovation-awards.png";
import * as S from "./signup.footer.styles";

const FooterLogos = [
  HMRC,
  Which,
  WinnerAccounting,
  ContractingAwards,
  TrustPilot,
  UkCloud,
  InnovationAwards,
];

export const SignupFooter = () => {
  const renderFooterLogos = FooterLogos.map((image) => (
    <S.FooterImage alt={image} src={image} key={image} />
  ));

  return (
    <S.SignUpFooter>
      <S.FooterLogo>{renderFooterLogos}</S.FooterLogo>
    </S.SignUpFooter>
  );
};
